import { baseApi } from 'sama-shared';

export interface PartnerLocationDto {
  id: string;
  name: string;
  address: string;
  latitude?: number;
  longitude?: number;
  mapsUrl?: string;
  whatsappNumber?: string | null;
  openingTime?: string | null;
  closingTime?: string | null;
  isOpenForOrders: boolean;
  timezone: string;
}

export interface CreatePartnerLocationDto {
  name: string;
  address: string;
  latitude?: number;
  longitude?: number;
  mapsUrl?: string;
  whatsappNumber?: string;
  openingTime?: string;
  closingTime?: string;
  isOpenForOrders?: boolean;
  timezone?: string;
}

export const locationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyLocations: builder.query<PartnerLocationDto[], void>({
      query: () => ({
        url: '/partner-location',
        method: 'GET',
      }),
      transformResponse: (response: any): PartnerLocationDto[] => {
        if (Array.isArray(response)) return response;
        if (response?.data && Array.isArray(response.data)) return response.data;
        if (response?.items && Array.isArray(response.items)) return response.items;
        return [];
      },
      providesTags: ['PartnerLocation'],
    }),
    createPartnerLocation: builder.mutation<PartnerLocationDto, CreatePartnerLocationDto>({
      query: (body) => ({
        url: '/partner-location',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['PartnerLocation'],
    }),
    updatePartnerLocation: builder.mutation<
      PartnerLocationDto,
      { id: string } & Partial<CreatePartnerLocationDto>
    >({
      query: ({ id, ...body }) => ({
        url: `/partner-location/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['PartnerLocation'],
    }),
    togglePartnerLocationOpen: builder.mutation<
      PartnerLocationDto,
      { id: string; isOpenForOrders: boolean }
    >({
      query: ({ id, isOpenForOrders }) => ({
        url: `/partner-location/${id}/toggle-open`,
        method: 'PATCH',
        body: { isOpenForOrders },
      }),
      invalidatesTags: ['PartnerLocation'],
    }),
    deletePartnerLocation: builder.mutation<void, string>({
      query: (id) => ({
        url: `/partner-location/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PartnerLocation'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetMyLocationsQuery,
  useCreatePartnerLocationMutation,
  useUpdatePartnerLocationMutation,
  useTogglePartnerLocationOpenMutation,
  useDeletePartnerLocationMutation,
} = locationsApi;
